import { createContext, useContext } from "react"

export const FlowProjectContext = createContext<number | null>(null)

export function useFlowProjectId(): number | null {
  return useContext(FlowProjectContext)
}
